import React from 'react';
import PropTypes from 'prop-types';
import { Table } from '@mui/material';
import AuthorizationsListResponsiveTableHead from './AuthorizationListResponsiveTableHead';
import AuthorizationsListResponsiveTableBody from './AuthorizationListResponsiveTableBody';
import { TableContainerMaxHeight } from 'components/list/TableComponentsStyled';

const AuthorizationListResponsiveTable = ({
  authorizations,
  userGroups,
  dispatch,
  onRefineAuthorization,
  onUnrefineAuthorization,
  changedPermissions
}) => {
  return (
    <TableContainerMaxHeight>
      <Table stickyHeader>
        <AuthorizationsListResponsiveTableHead userGroups={userGroups} />
        <AuthorizationsListResponsiveTableBody
          userGroups={userGroups}
          authorizations={authorizations}
          dispatch={dispatch}
          changedPermissions={changedPermissions}
          onRefineAuthorization={onRefineAuthorization}
          onUnrefineAuthorization={onUnrefineAuthorization}
        />
      </Table>
    </TableContainerMaxHeight>
  );
};

AuthorizationListResponsiveTable.propTypes = {
  changedPermissions: PropTypes.object.isRequired,
  authorizations: PropTypes.array.isRequired,
  userGroups: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  onRefineAuthorization: PropTypes.func.isRequired,
  onUnrefineAuthorization: PropTypes.func.isRequired
};

export default AuthorizationListResponsiveTable;
